import { Button, cn } from '@1trading/react';
import { Check, Copy } from 'lucide-react';
import { useRef, useState } from 'react';
import { toast } from 'sonner';

const COPIED_FEEDBACK_MS = 1500;

interface CopyButtonProps {
  value: string;
  label?: string;
  className?: string;
}

export const CopyButton = ({ value, label = 'Copy', className }: CopyButtonProps) => {
  const [isCopied, setIsCopied] = useState(false);
  const resetTimer = useRef<ReturnType<typeof setTimeout>>(undefined);

  const handleCopy = async (event: React.MouseEvent) => {
    // Never trigger surrounding row-click handlers
    event.stopPropagation();
    try {
      await navigator.clipboard.writeText(value);
      setIsCopied(true);
      clearTimeout(resetTimer.current);
      resetTimer.current = setTimeout(() => setIsCopied(false), COPIED_FEEDBACK_MS);
    } catch {
      toast.error('Could not copy to clipboard');
    }
  };

  return (
    <Button aria-label={label} className={cn('size-6', className)} onClick={handleCopy} size="icon" type="button" variant="ghost">
      {isCopied ? <Check className="size-3.5 text-emerald-500" /> : <Copy className="size-3.5" />}
    </Button>
  );
};
CopyButton.displayName = 'CopyButton';
